module.exports = __webpack_public_path__ + "img/checked.64d70a17.png";